var comments_divs = $('.comments .comment_block[data-pid="0"]');

$(document).ready(function ()
{
	add_comment_handlers();
	$('.sort_rating').click();
});

function add_comment_handlers()
{
	$('.sort_rating').click(function ()
	{
		sort_by_rating($(this), 'rating');
		$('.sort_date').removeClass('comments_sorted');
		$(this).addClass('comments_sorted');
	});

	$('.sort_date').click(function ()
	{
		sort_by_rating($(this), 'date');
		$('.sort_rating').removeClass('comments_sorted');
		$(this).addClass('comments_sorted');
	});
}

function sort_by_rating(caller, sort_type)
{
	var arrow = 8673;
	var direction = caller.attr('data-dir');
	var sorted_divs = comments_divs.sort(function (a, b)
	{
		if (direction == 1)
		{
			if ($(a).data(sort_type) * 1 > $(b).data(sort_type) * 1) return -1;
			else if ($(a).data(sort_type) * 1 < $(b).data(sort_type) * 1) return 1;
			else return 0;
		}
		else
		{
			if ($(a).data(sort_type) * 1 < $(b).data(sort_type) * 1) return -1;
			else if ($(a).data(sort_type) * 1 > $(b).data(sort_type) * 1) return 1;
			else return 0;
		}
	});
	direction ^= 1;
	if (direction == 1) arrow = 8675;
	caller.attr('data-dir', direction);
	caller.find('.direction').html('&#' + arrow + ';');
	$('.comments').html(sorted_divs);
	add_button_handlers();
}

function add_button_handlers()
{
	add_delete_action();
	add_edit_action();
	add_reply_action();
	add_vote_action();
}

function filter_comments(checkbox)
{
	var state = ($(checkbox).is(':checked'));

	if (state == true)
	{
		$('.comment_block[data-lang!="'+lang+'"]').each(function ()
			{
				$(this).hide();
			}
		);
	}
	else
	{
		$('.comment_block').each(function ()
			{
				$(this).show();
			}
		);
	}

}